"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbLoadMonthlyBCFP = void 0;
var moment = require("moment");
var collectionNames_1 = require("../../../../db/collectionNames");
var types_1 = require("../../../../utils/data/types");
var dbLoadMonthlyBCFP = function (db, config) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedAfterTimestamp, origin, destination, depart, roundTrip, mDepart, fpsCollection, query, dbFlightStatisticPrices, addedDatesDic, dbFPSMonthlyBCFPs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                updatedAfterTimestamp = config.updatedAfterTimestamp, origin = config.origin, destination = config.destination, depart = config.depart, roundTrip = config.roundTrip;
                mDepart = moment(depart);
                return [4 /*yield*/, db.connection.getCollection(collectionNames_1.DB_COLLECTION_FlightPriceStatistics)];
            case 1:
                fpsCollection = _a.sent();
                query = {
                    "updated.timestamp": { $gte: updatedAfterTimestamp },
                    origin: origin.toLowerCase(),
                    destination: destination.toLowerCase(),
                    "depart.date": {
                        $gte: mDepart.startOf('month').format(types_1.YYYYMMDD),
                        $lte: mDepart.startOf('month').add(1, 'month').endOf('month').format(types_1.YYYYMMDD),
                    },
                    return_: roundTrip ? { $ne: null } : { $eq: null },
                };
                return [4 /*yield*/, db.connection.getAllDocuments(fpsCollection
                        .find(query)
                        .sort({
                        "updated.timestamp": -1,
                    }))];
            case 2:
                dbFlightStatisticPrices = _a.sent();
                addedDatesDic = {};
                dbFPSMonthlyBCFPs = dbFlightStatisticPrices
                    .reduce(function (acc, dbItem) {
                    if (!addedDatesDic[dbItem.depart.date]) {
                        addedDatesDic[dbItem.depart.date] = true;
                        acc.push(dbItem);
                    }
                    return acc;
                }, [])
                    .map(function (dpFlightStatisticPrice) {
                    var updated = dpFlightStatisticPrice.updated.timestamp, date = dpFlightStatisticPrice.depart.date, bestPrice = dpFlightStatisticPrice.bestPrice, cheapestPrice = dpFlightStatisticPrice.cheapestPrice, fastestPrice = dpFlightStatisticPrice.fastestPrice, isLoading = dpFlightStatisticPrice.isLoading;
                    return {
                        date: date,
                        bestPrice: bestPrice,
                        cheapestPrice: cheapestPrice,
                        fastestPrice: fastestPrice,
                        updated: updated,
                        isLoading: isLoading,
                    };
                });
                return [2 /*return*/, dbFPSMonthlyBCFPs];
        }
    });
}); };
exports.dbLoadMonthlyBCFP = dbLoadMonthlyBCFP;
/*
  Query
   { 'updated.timestamp': { '$gte': 974678400000 },
        origin: 'vie',
        destination: 'lax',
        'depart.date': { '$gte': '2000-12-01', '$lte': '2001-01-31' },
        return_: { '$eq': null } }

*/
//# sourceMappingURL=dbLoadFlightStatisticPrices.js.map